import { useAuth } from '../lib/auth.jsx';
import { useT } from '../lib/i18n.jsx';

// Account deletion is deliberately absent from the web portal. The destructive
// flow lives only in the mobile app, which is where the store policies that
// require it (Apple 5.1.1(v), Play account deletion) expect to find it. The
// backend route POST /api/auth/delete still exists for the app — it is simply
// not reachable from here.
export default function Account() {
  const t = useT();
  const { user, signOut } = useAuth();

  return (
    <>
      <header className="page-head">
        <h1>{t('account.title')}</h1>
      </header>

      <section className="card">
        <dl className="detail-list">
          <div>
            <dt>{t('account.email')}</dt>
            <dd dir="ltr">{user?.email || t('common.none')}</dd>
          </div>
          <div>
            <dt>{t('account.country')}</dt>
            <dd>{user?.country || t('common.none')}</dd>
          </div>
        </dl>
      </section>

      <section className="card">
        <h2>{t('account.signOutTitle')}</h2>
        <p className="muted">{t('account.signOutBody')}</p>
        <button type="button" className="btn" onClick={signOut}>
          {t('nav.signOut')}
        </button>
      </section>
    </>
  );
}
